import { render, staticRenderFns } from "./ApacheLicenseView.vue?vue&type=template&id=97fc7738&scoped=true"
import script from "./ApacheLicenseView.vue?vue&type=script&lang=js"
export * from "./ApacheLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fc7738",
  null
  
)

export default component.exports